import React, { useState, useEffect, useContext } from "react";
import "./landing.css";


import Layout from "../../../components/Layout/Layout";
import LabLayout from "../../../components/LabLayout/LabLayout";

import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";

import BeatLoader from "react-spinners/BeatLoader";

import { db } from "../../../firebase/firebase-config";
import { Table, Input, Select } from 'antd';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../../firebase/firebase-config';

import { collection, query, where, getDocs } from "firebase/firestore";
import { User } from "firebase/auth";
import { getCurrentUserId } from "../../../utils/storage";
import LabReportModal from "../../../components/ui/LabReportModal/LabReportModal";
import LabAddPatientModal from "../../../components/ui/LabAddPatientModal/LabAddPatientModal";
import { useTranslation } from 'react-i18next';

import { DownOutlined } from '@ant-design/icons';
import type { TableColumnsType } from 'antd';
import { Badge, Dropdown, Space } from 'antd';
import DataTable from "./DataTable";
const { Search } = Input;



interface DataType {
  key: React.Key;
  name: string;
  platform: string;
  version: string;
  upgradeNum: number;
  creator: string;
  createdAt: string;
}

interface ExpandedDataType {
  key: React.Key;
  date: string;
  name: string;
  upgradeNum: string;
}


const override = {
  marginTop: "20px",
};

function Index() {
  const data: DataType[] = [];


  const [allReportsData, setAllReportsData] = useState([]);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [showAddReportModal, setShowAddReportModal] = useState(false);
  const [activePatientData, setActivePatientData] = useState(null);
  const [searchText, setSearchText] = useState<string>('');
  const [filteredData, setFilteredData] = useState<any[]>(allReportsData);

  const { t, i18n } = useTranslation();

  const [user] = useAuthState(auth);


  const [loading, setLoading] = useState(false);

  const toggleAddModal = async () => {
    // fetchUsers().then(doc => console.log(doc.data()))
    setShowCreateModal(!showCreateModal);
  };

  const toggleAddReportModal = async () => {
    // fetchUsers().then(doc => console.log(doc.data()))
    setShowAddReportModal(!showAddReportModal);
  };

  const handleContentAdded = () => {
    toggleAddModal();
    //FETCH DATA
    fetchData();
  };

 
  const handleReportAdded = () => {
    toggleAddReportModal();
    fetchData();

  }

  
  const fetchData = async () => {
    setLoading(true);

    const q = query(collection(db, "Reports"), where("owner", "==", user?.uid));

    const querySnapshot = await getDocs(q);

    const reportsData: any = [];
    querySnapshot.forEach((doc) => {
      reportsData.push({
        key: doc.id,
        ...doc.data()
      })
      console.log(doc.id, " => ", doc.data());
    });
    
    setAllReportsData(reportsData)
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const [sortedInfo, setSortedInfo] = useState<any>({});

  const handleChange = (pagination: any, filters: any, sorter: any) => {
    setSortedInfo(sorter);
  };


  allReportsData.forEach((item: any, index: any) => {
    item.index = index + 1;
  });

  useEffect(() => {
    setFilteredData(filterData(allReportsData, searchText));
  }, [allReportsData, searchText]);

  const filterData = (data: any[], query: string) => {
    if (!query) return data;

    return data.filter((item) =>
      Object.values(item).some((value: any) =>
        value.toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  };


  const handleSearch = (value: string) => {
    setSearchText(value);
  };


  return (
    <>
      <LabLayout title={t('lab.home_title')} pageTitle={t('lab.reports_text')}>
        <div className="section">
          <div className="parent-con">
            <div className="data-table">
              <div className="top">
                <div className="span">
                  <h3> {t('lab.all_reports')}</h3>
                </div>

                <button
                  onClick={toggleAddModal}
                  className="btn btn-primary btn-add student-button"
                >
                  {" "}
                 {t("lab.add_modal.add_text")}{" "}
                </button>
              </div>
              <div className="table-con">
                <div style={{ textAlign: "center" }}>
                  <BeatLoader
                    color="#3080ED"
                    loading={loading}
                    cssOverride={override}
                  />
                </div>
                <Search
                  placeholder={`${t('lab.search_label')}`}
                  onSearch={handleSearch}
                  onChange={(e) => handleSearch(e.target.value)}
                  value={searchText}
                  style={{ width: 200, marginBottom: 16 }}
                />

                {/* <Table

                  dataSource={filteredData.map((item, index) => ({ ...item, index: index + 1 }))}

                  columns={rows}
                  onChange={handleChange}
                  rowKey="num"
                  showSorterTooltip={false}

                  pagination={{ pageSize: 10 }}
                /> */}

                  <DataTable
                      data = {filteredData}
                      toggleAddReportModal={toggleAddReportModal}
                      setActivePatientData={setActivePatientData}
                      // key={tableKey}
                  />

              </div>
           
            </div>
          </div>
        </div>

      </LabLayout>
      {showAddReportModal && (
        <LabReportModal
          onContentAdded={handleReportAdded}
          onClose={toggleAddReportModal}
          patient={activePatientData}
        />
      )}
  {showCreateModal && (
        <LabAddPatientModal
          onContentAdded={handleContentAdded}
          onClose={toggleAddModal}
        />
      )} 

    </>
  );
}

export default Index;
